<template>
  <div class="common_box" v-if="discussList && discussList.length > 0">
    <div class="common_top">
      <div class="common_title">
        <img src="./images/discuss_title.png" alt="" />
      </div>

      <div class="invite_list" @click="toTopicPage">
        去围观
        <div class="right_arrow">
          <img src="./images/arrow.png" alt="" />
        </div>
        <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
      </div>
    </div>
    <div class="inner_box">
      <div class="discuss_box">
        <div class="tab_box">
          <div
            class="tab_item"
            :class="tabIndex === 0 ? 'tab_active' : ''"
            @click="toggleTab(0)"
          >
            最新
            <div :class="tabIndex === 0 ? 'red_line' : 'white_line'"></div>
          </div>
          <div
            class="tab_item"
            :class="tabIndex === 1 ? 'tab_active' : ''"
            @click="toggleTab(1)"
          >
            热门
            <div :class="tabIndex === 1 ? 'red_line' : 'white_line'"></div>
          </div>
          <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
        </div>
        <div style="min-height: 3rem">
          <div
            class="discuss_item"
            v-for="(item, index) in discussList"
            :key="index"
          >
            <div class="userinfo_box">
              <div class="avator_box" @click="toOwnPage(item)">
                <img :src="item && item.avatar" alt="" />
                <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
              </div>
              <div class="userinfo_right" @click="toOwnPage(item)">
                <p>{{ item && item.nickname }}</p>
                <span>{{ formatTime(item && item.create_time) }}</span>
                <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
              </div>
            </div>
            <div
              class="discuss_title"
              @click="toGubaContent(item, '0')"
              v-if="item && item.title"
            >
              <p v-html="dealContent(item && item.title)"></p>
              <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
            </div>
            <div class="discuss_text" @click="toGubaContent(item, '0')">
              <p v-html="dealContent(item && item.content)"></p>
              <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
            </div>
            <div
              class="discuss_pics"
              v-if="item && item.post_pic_url && item.post_pic_url.length > 0"
            >
              <div
                class="discuss_pic"
                v-for="(pic, index) in item.post_pic_url"
                :key="index"
                @click="toGubaContent(item, '0')"
              >
                <img :src="pic" v-if="pic" alt="" />
                <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
              </div>
            </div>
            <div class="discuss_btn_box">
              <div class="discuss_btn_item" @click="gubaShare(item)">
                <img src="./images/discuss_share.png" alt="" />
                <p>分享</p>
                <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
              </div>
              <div class="discuss_btn_item" @click="toGubaContent(item, '1')">
                <img src="./images/discuss_pinglun.png" alt="" />
                <p>
                  {{
                    item && item.CommentNumber > 0
                      ? item.CommentNumber
                      : filterLikeNumber("评论")
                  }}
                </p>
                <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
              </div>
              <div class="discuss_btn_item" @click="dianzanClick(item, index)">
                <img
                  v-if="item['post_is_like'] === false"
                  src="./images/discuss_zan.png"
                  alt=""
                />
                <img
                  v-else-if="item['post_is_like'] === true"
                  src="./images/discuss_zan_re.png"
                  alt=""
                />
                <p v-if="item['post_is_like'] === false">
                  {{ filterLikeNumber(item && item.LikeNumber) }}
                </p>
                <p class="red_font" v-else-if="item['post_is_like'] === true">
                  {{ filterLikeNumber(item && item.LikeNumber) }}
                </p>
                <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
              </div>
            </div>
            <div
              class="discuss_replys"
              @click="toGubaContent(item, '1')"
              v-if="item.reply_list && item.reply_list.length > 0"
            >
              <p v-html="dealReplyContent(item.reply_list[0])"></p>
              <div
                v-if="item.CommentNumber > 1"
                class="reply_more"
                @click="toGubaContent(item, '1')"
              >
                {{ `查看全部${item.CommentNumber}条评论` }}
              </div>
              <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
            </div>
          </div>
        </div>
        <div
          class="discuss_btn"
          @click="toTopicPage"
          tracker-eventcode="sy-ryht-jrrl_000"
        >
          <div class="ic_search">
            <img src="./images/discuss_search.png" alt="" />
          </div>
          <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, defineAsyncComponent } from "vue";
import { appInfo, nShare } from "@eastmoney/mku";
import fetchData from "@/utils/fetchData";
import { initBigFace, parseEmoji } from "@/utils/emoj";
import { $loading, $toast } from "@/utils/globalUtils";
const WxOpenAppItm = defineAsyncComponent(() =>
  import("@/components/WxOpenAppItm.vue").then(
    (module: any) => module.default || module
  )
);
import { getCookie, getActConfigInfo } from "@/utils/common";
const emit = defineEmits(["callLoginHandle"]);
/** pinia */
/** pinia */
import { storeToRefs } from "pinia";
import { useMainStore } from "@/pinia/main";
const { setUserInfo, hasAuth } = useMainStore();
const { haslogin, userObj } = storeToRefs(useMainStore()); // 又读又写的时候使用ref响应式

// state
const tabIndex = ref<number>(1);
const discussList = ref<any[]>([]);
const topicId = ref<string>("11621");

onMounted(() => {
  initBigFace();
  getHotTopicList();
});

// 工具函数（替代过滤器）
const filterLikeNumber = (val: number | string): string | number => {
  if (typeof val === "number" && val > 999) return "999+";
  return val;
};

const formatTime = (val?: string): string => {
  if (!val) return "";
  let s = String(val).trim();
  // 兼容 iOS Safari 不支持某些 date string 的解析（比如 "YYYY-MM-DD HH:mm:ss"）
  // 优先把常见的空格分隔日期时间转换为 ISO 格式
  if (/^\d{4}-\d{2}-\d{2} \d{2}:/.test(s)) {
    s = s.replace(" ", "T");
  }

  let date = new Date(s);
  // 若仍然无效，尝试将横杠替换为斜杠（部分 iOS 对 "YYYY/MM/DD" 更兼容）
  if (isNaN(date.getTime())) {
    const s2 = s.replace(/-/g, "/");
    date = new Date(s2);
  }

  // 最后兜底，手动解析常见时间格式：YYYY[-/.]MM[-/.]DD[ T]HH:mm:ss
  if (isNaN(date.getTime())) {
    const m = s.match(
      /(\d{4})[^\d]?(\d{1,2})[^\d]?(\d{1,2})(?:[^\d]?(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/
    );
    if (m) {
      date = new Date(
        Number(m[1]),
        Number(m[2]) - 1,
        Number(m[3]),
        Number(m[4] || 0),
        Number(m[5] || 0),
        Number(m[6] || 0)
      );
    } else {
      return "";
    }
  }

  const now = new Date();
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
  const MM = pad(date.getMonth() + 1);
  const DD = pad(date.getDate());
  const HH = pad(date.getHours());
  const mm = pad(date.getMinutes());
  return isToday ? `今天 ${HH}:${mm}` : `${MM}-${DD} ${HH}:${mm}`;
};

// 解析表情
const dealContent = (html: string): string => {
  console.log(parseEmoji(html), "----parseEmoji(html)");

  return parseEmoji(html);
};

const dealReplyContent = (replyItem: any): string => {
  let name =
    replyItem.reply_user.user_nickname || replyItem.reply_user.user_name;
  name = `<span style=\"font-weight:bold\">${name}：</span>`;
  let reply = dealContent(replyItem.reply_text);
  return `${name}${reply}`;
};

// 交互方法
const toggleTab = (index: number) => {
  appInfo.inApp(
    () => {
      if (tabIndex.value === index) return;
      tabIndex.value = index;
      $loading.show();
      if (index === 0) {
        getNewTopicList();
      } else {
        getHotTopicList();
      }
    },
    () => {
      linkAppMed();
    }
  );
};

/**
 * 跳转承接页
 */
const linkAppMed = () => {
  window.linkAppMed();
};

const getNewTopicList = () => {
  const obj = {
    api: `/api/guba/Topic/NewTopicPostListRead`,
    headers: {
      pvi: getCookie("st_pvi"),
    },
    data: {
      ctoken: userObj.value.ct,
      utoken: userObj.value.ut,
      deviceid: userObj.value["EM-MD"] || "100",
      version: userObj.value["EM-VER"] || "10.20",
      plat: appInfo.isIOS ? "Iphone" : "Android",
      product: "EastMoney",
      htid: topicId.value,
    },
    success: (res: any) => {
      $loading.hide();
      if (res && res.rc === 1) {
        if (res.re && res.re.length) {
          const _list: any[] = [];
          for (let i = 0; i < res.re.length; i++) {
            res.re[i].content = res.re[i].content.replace(
              "#2024金融安全知识网络比拼#",
              ""
            );
            if (res.re[i].content && res.re[i].content.length) {
              if (res.re[i].post_pic_url && res.re[i].post_pic_url.length > 3) {
                res.re[i].post_pic_url.length = 3;
              }
              _list.push(res.re[i]);
            }
            if (_list.length >= 1) {
              discussList.value = JSON.parse(JSON.stringify(_list));
              return;
            } else {
              discussList.value = [];
            }
          }
        }
      } else {
        discussList.value = [];
        // $toast.show(res && res["me"]);
      }
    },
  };
  fetchData.doPost(obj);
};

const getHotTopicList = () => {
  const obj = {
    api: `/api/guba/Topic/TopicMostHotRead`, 
    headers: {
      pvi: getCookie("st_pvi"),
    },
    data: {
      ctoken: userObj.value.ct,
      utoken: userObj.value.ut,
      deviceid: userObj.value["EM-MD"] || "100",
      version: userObj.value["EM-VER"] || "10.20",
      plat: appInfo.isIOS ? "Iphone" : "Android",
      product: "EastMoney",
      htid: topicId.value,
    },
    success: (res: any) => {
      $loading.hide();
      if (res && res.rc === 1) {
        if (res.re && res.re.length) {
          const _list: any[] = [];
          for (let i = 0; i < res.re.length; i++) {
            res.re[i].content = res.re[i].content.replace(
              "#2024金融安全知识网络比拼#",
              ""
            );
            if (res.re[i].content && res.re[i].content.length) {
              if (res.re[i].post_pic_url && res.re[i].post_pic_url.length > 3) {
                res.re[i].post_pic_url.length = 3;
              }
              _list.push(res.re[i]);
            }
            if (_list.length >= 1) {
              discussList.value = JSON.parse(JSON.stringify(_list));
              return;
            } else {
              discussList.value = [];
            }
          }
        }
      } else {
        discussList.value = [];
        // $toast.show(res && res["me"]);
      }
    },
  };
  fetchData.doPost(obj);
};

const gubaShare = (item: any) => {
  appInfo.inApp(
    () => {
      const targetUrl =
        "http://mguba.eastmoney.com/mguba/article/0/" + item.postid;
      nShare({
        type: "weixin,pengyouquan,weibo,qq",
        title: item.title,
        img:
          window.location.origin + "/views/matchesguess/static/sharelogo.png",
        url: targetUrl,
        desc: item.content,
        callback: (res: string) => {
          if (res === "error") {
            $toast.show("分享失败，请先查看是否已安装相应的App哦～");
          } else if (res === "cancel") {
            // 用户取消
          } else {
            if (["weixin", "pengyouquan", "qq", "weibo"].includes(res)) {
              const channelObj: Record<string, string> = {
                qq: "1",
                weibo: "2",
                weixin: "3",
                pengyouquan: "4",
              };
              const channel = channelObj[res];
              if (haslogin.value) {
                reportPostShare(item, channel);
              }
            }
          }
        },
      });
    },
    () => {
      linkAppMed();
    }
  );
};

const reportPostShare = (item: any, channel: string) => {
  const obj = {
    api: `/shareopt/api/PostShare/ReportPostShare?ctoken=${
      userObj.value.ct
    }&utoken=${userObj.value.ut}&deviceid=${userObj.value["EM-MD"]}&version=${
      userObj.value["EM-VER"]
    }&plat=${appInfo.isIOS ? "Iphone" : "Android"}&product=EastMoney&postid=${
      item.postid
    }&type=0&shareType=${channel}`,
    domain: "follow",
    headers: { pvi: getCookie("st_pvi") },
    success: (_res: any) => {},
  };
  fetchData.doPost(obj);
};

const dianzanClick = (item: any, index: number) => {
  appInfo.inApp(
    () => {
      emit("callLoginHandle", () => {
        $loading.show();
        if (item["post_is_like"] === false) {
          const obj = {
            api: `/likeopt/api/Like/LikeArticle?id=${
              item.postid
            }&type=0&ctoken=${userObj.value.ct}&utoken=${
              userObj.value.ut
            }&deviceid=${userObj.value["EM-MD"]}&version=${
              userObj.value["EM-VER"]
            }&plat=${appInfo.isIOS ? "Iphone" : "Android"}&product=EastMoney`,
            domain: "follow",
            headers: { pvi: getCookie("st_pvi") },
            success: (res: any) => {
              $loading.hide();
              if (res && res.rc === 1) {
                discussList.value[index].LikeNumber++;
                discussList.value[index].post_is_like = true;
              } else {
                $toast.show(res && res["me"]);
              }
            },
          };
          fetchData.doPost(obj);
        } else if (item["post_is_like"] === true) {
          const obj = {
            api: `/likeopt/api/Like/CancelLikeArticle?id=${
              item.postid
            }&type=0&ctoken=${userObj.value.ct}&utoken=${
              userObj.value.ut
            }&deviceid=${userObj.value["EM-MD"]}&version=${
              userObj.value["EM-VER"]
            }&plat=${appInfo.isIOS ? "Iphone" : "Android"}&product=EastMoney`,
            domain: "follow",
            headers: { pvi: getCookie("st_pvi") },
            success: (res: any) => {
              $loading.hide();
              if (res && res.rc === 1) {
                discussList.value[index].LikeNumber--;
                discussList.value[index].post_is_like = false;
              } else {
                $toast.show(res && res["me"]);
              }
            },
          };
          fetchData.doPost(obj);
        }
      });
    },
    () => {
      linkAppMed();
    }
  );
};
const toGubaContent = (item: any, tocomment = "0") => {
  appInfo.inApp(
    () => {
      if (appInfo.isIOS) {
        window.location.href = `eastmoney://wireless/gubacontent?postid=${item.postid}&posttype=0&tocomment=${tocomment}`;
      } else {
        window.location.href = `dfcft://gubacontent?postid=${item.postid}&posttype=0&tocomment=${tocomment}`;
      }
    },
    () => {
      linkAppMed();
    }
  );
};

const toTopicPage = () => {
  appInfo.inApp(
    () => {
      if (appInfo.isIOS) {
        window.location.href = `eastmoney://wireless/h5/nonavweb?url=https%3A%2F%2Fmgubatopic.eastmoney.com%2Flist%3Fid%3D${topicId.value}&emthemenavmode=1`;
      } else {
        window.location.href = `dfcft://router/h5?titleBarType=trans&url=https%3A%2F%2Fmgubatopic.eastmoney.com%2Flist%3Fid%3D${topicId.value}`;
      }
    },
    () => {
      linkAppMed();
    }
  );
};

const toOwnPage = (item: any) => {
  appInfo.inApp(
    () => {
      if (appInfo.isIOS) {
        window.location.href = `eastmoney://wireless/stockbarselfpage?anchor=0&userid=${item.userid}`;
      } else {
        window.location.href = `dfcft://gubauserhome?anchor=0&uid=${item.userid}`;
      }
    },
    () => {
      linkAppMed();
    }
  );
};
</script>

<style lang="scss" scoped>
.common_box {
  margin-top: 0.36rem;
  .common_top {
    box-sizing: border-box;
    padding-top: 0.18rem;
    padding-left: 0.28rem;
    position: relative;
    width: 6.86rem;
    height: 1.94rem;
    background: url("./images/common_top.png") no-repeat;
    background-size: 6.86rem 1.94rem;
    border-radius: 0.36rem 0.36rem 0 0;
    display: flex;
    justify-content: center;
    .common_title {
      width: 1.31rem;
      height: 0.4rem;
      padding-top: 0.16rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .invite_question {
      margin-left: 0.08rem;
      margin-top: 0.08rem;
      width: 0.3rem;
      height: 0.3rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .invite_list {
      width: 1.3rem;
      position: absolute;
      display: flex;
      right: 0.2rem;
      top: 0.3rem;
      font-size: 0.28rem;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      .right_arrow {
        margin-left: 0.1rem;
        width: 0.08rem;
        height: 0.14rem;
        font-size: 0;
        img {
          width: 0.1rem;
          height: 0.16rem;
        }
      }
    }
  }
  .inner_box {
    position: relative;
    margin-top: -0.9rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 6.86rem;
    min-height: 3rem;
    height: auto;
    background-color: #ffffff;
    border-radius: 0.36rem;
    padding-bottom: 0.18rem;
    .discuss_box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      height: auto;
      width: 6.48rem;
      // padding: 0.24rem;
      padding-top: 0.3rem;
      background: #ffffff;
      border-radius: 0.24rem;
      .tab_box {
        position: relative;
        display: flex;
        width: 100%;
        .tab_item {
          width: 0.9rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 0.26rem;
          color: #999999;
          .red_line {
            width: 0.34rem;
            height: 0.1rem;
            background: #ff5500;
            background: url("./images/active_bgc.png") no-repeat;
            background-size: 100% 100%;
          }
          .white_line {
            width: 0.34rem;
            height: 0.1rem;
            background: #ff5500;
            opacity: 0;
          }
        }
        .tab_active {
          font-size: 0.3rem;
          font-weight: bold;
          color: #000;
        }
      }
      .discuss_item {
        width: 6.26rem;
        box-sizing: border-box;
        padding: 0.24rem 0;
        margin: 0 auto;
        // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .userinfo_box {
          display: flex;
          align-items: center;
          .avator_box {
            position: relative;
            width: 0.64rem;
            height: 0.64rem;
            font-size: 0;
            border-radius: 50%;
            border: 0.01rem solid rgba($color: #000000, $alpha: 0.1);
            img {
              width: 0.64rem;
              height: 0.64rem;
              border-radius: 50%;
            }
          }
          .userinfo_right {
            position: relative;
            margin-left: 0.16rem;
            padding-top: 0.06rem;
            p {
              font-size: 0.26rem;
              color: #333;
              font-weight: bold;
              line-height: 1.1;
            }
            span {
              font-size: 0.22rem;
              color: #999;
              line-height: 1.1;
            }
          }
        }
        .discuss_text {
          position: relative;
          width: 100%;
          margin-top: 0.1rem;
          p {
            width: 100%;
            color: #333;
            text-align: left;
            font-size: 0.26rem;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; /*想省略几行就写几*/
            -webkit-box-orient: vertical;
            line-clamp: 3;
          }
        }
        .discuss_title {
          position: relative;
          width: 100%;
          margin-top: 0.1rem;
          p {
            width: 100%;
            color: #333;
            text-align: left;
            font-size: 0.3rem;
            line-height: 1.4;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /*想省略几行就写几*/
            -webkit-box-orient: vertical;
            line-clamp: 2;
          }
        }
        .discuss_pics {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          margin-top: 0.1rem;
          .discuss_pic {
            margin-right: 0.04rem;
            position: relative;
            width: 2rem;
            height: 2rem;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .discuss_pic:nth-child(n + 4) {
            margin-top: 0.1rem;
          }
        }
        .discuss_btn_box {
          display: flex;
          align-items: center;
          margin: 0.24rem 0 0.1rem;
          .discuss_btn_item {
            width: 1.8rem;
            position: relative;
            display: flex;
            align-items: center;
            font-size: 0;
            img {
              width: auto;
              height: 0.36rem;
              transform: scale(0.9);
              transform-origin: center top;
            }
            p {
              font-size: 0.24rem;
              color: #666;
              margin-left: 0.06rem;
            }
            .red_font {
              color: #ff5500;
            }
          }
        }
        .discuss_replys {
          position: relative;
          width: 100%;
          margin-top: 0.5rem;
          p {
            width: 100%;
            color: #666;
            text-align: left;
            font-size: 0.28rem;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /*想省略几行就写几*/
            -webkit-box-orient: vertical;
            line-clamp: 2;
          }
          .reply_more {
            color: rgb(79, 115, 175);
            font-size: 0.24rem;
            line-height: 2;
            margin-top: 0.05rem;
          }
        }
      }
      .discuss_item:nth-last-child(2) {
        border: none !important;
      }
      .discuss_btn {
        position: relative;
        width: 6.32rem;
        height: 0.76rem;
        display: flex;
        align-items: center;
        background: url("./images/discuss_bottom.png") no-repeat;
        background-size: 100% 100%;
        .ic_search {
          margin-left: 0.3rem;
          width: 0.32rem;
          height: 0.28rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>